import { render, staticRenderFns } from "./EventDocumentation.vue?vue&type=template&id=55997723&scoped=true&"
import script from "./EventDocumentation.vue?vue&type=script&lang=js&"
export * from "./EventDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./EventDocumentation.vue?vue&type=style&index=0&id=55997723&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55997723",
  null
  
)

export default component.exports